var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Table } from '../../../components';
import history from '../../../helpers/History';
var CollaboratorStretchesTable = /** @class */ (function (_super) {
    __extends(CollaboratorStretchesTable, _super);
    function CollaboratorStretchesTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleSelectItem = function (value) {
            history.push("/collaboratortretches/".concat(value.operator_id, "/").concat(value.id));
        };
        return _this;
    }
    CollaboratorStretchesTable.prototype.render = function () {
        var collaboratorStretches = this.props.collaboratorStretches;
        var headers = ['operatorName', 'name', 'origin', 'destination'];
        return (React.createElement("div", null,
            React.createElement(Table, { keyExtractor: function (item) { return String(item.id); }, items: collaboratorStretches, header: headers, onSelectItem: this.handleSelectItem }),
            React.createElement("div", { style: {
                    width: '100%',
                    position: 'absolute',
                    bottom: 0,
                    // borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
                } })));
    };
    CollaboratorStretchesTable = __decorate([
        inject('store'),
        loading(function (props) {
            return [
                props.store.collaboratorStretchesStore.read().then(function (collaboratorStretches) { return ({ collaboratorStretches: collaboratorStretches }); })
            ];
        })
    ], CollaboratorStretchesTable);
    return CollaboratorStretchesTable;
}(Component));
export default CollaboratorStretchesTable;



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/container/CollaboratorStretchesTable.tsx
// module id = 1585
// module chunks = 0